function isUserDeleted(user = {}) {
  if (user.is_deleted === true || user.is_deleted === 1) return true;
  if (user.isDeleted === true || user.isDeleted === 1) return true;
  if (user.deleted === true || user.deleted === 1) return true;

  const status = typeof user.status === "string" ? user.status.toLowerCase() : "";
  return status === "deleted";
}

export default isUserDeleted;
